import { stringify } from "query-string"
import { apiInstance } from "./api"

const endpoint = "/category"

export const getAllCategories = async queries => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const addCategory = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const getCategory = async categoryId => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}?_id=${categoryId}`)

  return response.data
}

export const editCategory = async (categoryId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}?_id=${categoryId}`, data)

  return response.data
}